<script setup>
import { usePageHead } from '@composables/use-page-head'
import { computed } from 'vue'
import { usePremiumStore } from '@stores/premium'
import AudioQuality from './audio-quality'
import ExternalPlayer from './external-player'

// `<component :is>` resolves a STRING against registered components, never against
// <script setup> bindings — the routes name the tab, so the name is mapped back here.
const MAIN_COMPONENTS = { AudioQuality, ExternalPlayer }

const props = defineProps({
    mainComponent: {
        type: String,
        default: 'AudioQuality',
    },
})

const premiumStore = usePremiumStore()

const mainView = computed(() => MAIN_COMPONENTS[props.mainComponent])

const isPremium = computed(() => premiumStore.isPremium)

const tabs = computed(() => [
    { to: { name: 'settings/audio-quality' }, label: 'Audio Quality' },
    {
        to: { name: 'settings/external-player' },
        label: isPremium.value ? 'External Players' : 'External Players (Premium only)',
    },
])

usePageHead({ title: 'Settings', description: 'Settings' })
</script>

<template>
    <BaseContent title="Settings">
        <BaseTabPanel
            :tabs="tabs"
            class="tabs"
            is-underlined
            is-unpadded
            address-navigation
        />
        <component :is="mainView" />
    </BaseContent>
</template>

<style lang="scss" scoped>
@import '@design';

.tabs {
    margin-bottom: $s-xxl;
}
</style>
